import { IkeToken } from '@ikegps/core-api';
import type { MithrilVNode } from '../../mithril';
import { MultiListChooserContent, MultiListChooserTitle } from '../../modules/multi.list.chooser/multi.list.chooser';
import type { MultiChooserState } from '../../modules/multi.list.chooser/multi.list.chooser.state';
import { CSS as MultiListChooserCSS } from '../../modules/multi.list.chooser/multi.list.chooser.style';
import { NestedListChooserState } from '../../modules/multi.list.chooser/nested.list.chooser.state';
import { SelectListChooserState } from '../../modules/multi.list.chooser/select.list.chooser.state';
import { Services } from '../../services';
import { m } from '../../services/render.service';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { ModalService } from '../modal/modal.service';
import { addStyles } from '../theme';
import { CSS, Style } from './nested.list.input.style';

addStyles(Style);

export const MultiListInput = {
	view(state: MultiChooserState): MithrilVNode {
		let color: string | null = null;

		if (
			// If we have the correct token
			Services.Token.has(IkeToken.FEATURE_COLOR_FLAG) &&
			// And the state is one of the correct types
			(state instanceof SelectListChooserState || state instanceof NestedListChooserState) &&
			// And the state's field is the one marked as the color field
			state.field.collection.schema.metadata.mapColorFieldId === state.field.schema.id
		) {
			color = state.field.color;
		}

		const children = [m('span', { className: CSS.label }, state.displayValue)];

		if (color) {
			children.push(m('div', { className: CSS.colorIndicator, style: { backgroundColor: color } }));
		}

		children.push(Icon.view(MaterialIcon.FILTER_NONE, { className: CSS.edit }));

		return m('div', { className: CSS.container }, [
			m(
				'button',
				{
					className: `${CSS.button} mdl-button`,
					'data-testid': 'multi-list-button',
					onclick: (e: MouseEvent) => MultiListInput.viewModal(e.target as HTMLElement, state),
				},
				children
			),
		]);
	},

	async viewModal(element: HTMLElement, state: MultiChooserState) {
		if (ModalService.isOpen) {
			return;
		}

		state.setFocused(true);
		const oldValue = state.value != null ? state.value.slice() : null;

		const result = await ModalService.open({
			title: MultiListChooserTitle.view(state),
			content: () => MultiListChooserContent.view(state),
			className: MultiListChooserCSS.modal,
			hasCancel: true,
		});

		if (result.ok && state.value == null) {
			// Assign default value
			state.selectDefaultValue();
		} else if (!result.ok) {
			state.setValue(oldValue);
		}

		state.setFocused(false);
		element.focus();
	},
};
